/**
 * Opens a new browser pop-up window with the given URL.
 * Throws an error if the pop-up is blocked by the browser.
 *
 * @param {string} url - The URL to open in the pop-up window.
 * @returns {Window} The reference to the newly opened pop-up window.
 * @throws {Error} If the pop-up is blocked by the browser.
 */
export function openPopup(url) {
    const popup = window.open(url);

    if (!popup) {
      throw new Error('Pop-ups are blocked');
    }

    return popup;
}